module.exports = __webpack_public_path__ + "img/no-data.79276c08.svg";